import script from "./broadcast.vue?vue&type=script&lang=ts&setup=true"
export * from "./broadcast.vue?vue&type=script&lang=ts&setup=true"

import "./broadcast.vue?vue&type=style&index=0&id=338ec8f7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338ec8f7"]])

export default __exports__